<template>
  <!-- <div>ver comentarios</div> -->
  <b-modal
    v-model="isVisible"
    hide-footer
    size="lg"
  >

    <b-card>

      <h2 class="text-center mb-3">Observaciones de la atencion medica</h2>
      

      <div v-if="comentarios.length > 0">
        <!-- <v-select
          v-model="estadoRevision"
          :options="estadoRevisionOpts"
          label="text"
          placeholder="Estado de revision de la atencion medica"
        /> -->

        <b-table
          :items="comentarios" 
          :fields="tableFields"
          class="text-center mt-3"
          responsive small
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <template #cell(estadoComentario)="data">
            <span 
              v-if="data.item.estadoComentario === '1'"
              class="text-success"
            >
              Revisado
            </span>
          </template>

          <template #cell(ultimoCambio)="data">
            {{ formatDateToDB(data.item.ultimoCambio) }}
          </template>
        </b-table>

      </div>

      <EmptyResults 
        v-if="comentarios.length === 0"
        message="No hay observaciones registradas"
      />

    </b-card>
    
  </b-modal>
</template>

<script>
import { formatDateToDB } from "@/shared/helpers";
import { EmptyResults } from "@/shared/components";
import { atencionAuditoriaService } from '../../services';

export default {

  name: "AtencionAuditoriaVerComentarios",

  components: {
    EmptyResults
  },

  data() {
    return {

      isVisible: false,
      tokenAtencion: null,

      comentarios: [],

      tableFields: [
        { 
          key: "index", 
          label: "N°", 
          thClass: "text-center", 
          tdClass: "text-center" 
        },
        { 
          key: "tablaForanea", 
          label: "Campo", 
          thClass: "text-center" 
        },
        { 
          key: "comentario",    
          label: "Comentario",    
          thClass: "text-center",
          tdClass: "text-left"
        },
        { 
          key: "estadoComentario",       
          label: "Estado",       
          thClass: "text-center" 
        },

        { 
          key: "ultimoCambio",       
          label: "Fecha / Hora",       
          thClass: "text-center" 
        },

        { 
          key: "usuarioCreador.username",       
          label: "Auditor",       
          thClass: "text-center" 
        },
      ],

      formatDateToDB: formatDateToDB
    }
  },

  created() {
    this.setToken();
  },

  methods: {

    async onGetDataComments( ){
      const data = await atencionAuditoriaService.getCommentsByAtencion( this.tokenAtencion );

      if (data) this.comentarios = data;

      this.isVisible = true;
    },


    setToken(){
      this.tokenAtencion = this.$route.query.vcomments;
    }
  },

  watch: {
    '$route.query.vcomments': {
      handler(){ 
        this.setToken();
      },
    },

    tokenAtencion:{
      deep:true,
      handler(newValue){
        if(!newValue) return;
        this.onGetDataComments( newValue );
      }
    },


    isVisible: {
      deep: true,
      handler(newValue) {
        if( !newValue ) this.$router.push({ name: 'atenciones-medicas' })
      }
    }
  }


}
</script>
